import React, { useState } from 'react';
import { LicState } from '../types';

interface LicStateEditProps {
  licState: LicState;
  onSave: (updated: LicState) => void;
  onCancel: () => void;
}

const LicStateEdit: React.FC<LicStateEditProps> = ({ licState, onSave, onCancel }) => {
  const [form, setForm] = useState<LicState>({ ...licState });
  const [error, setError] = useState<string>('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type } = e.target;
    setForm(f => ({ ...f, [name]: type === 'number' ? (value === '' ? undefined : Number(value)) : value }));
  };

  const validate = () => {
    if (!form.state || form.state.trim() === '') return 'State name is required.';
    if (!form.stateID || isNaN(Number(form.stateID))) return 'State ID is required and must be a number.';
    return '';
  };

  const handleSave = () => {
    const err = validate();
    if (err) {
      setError(err);
      return;
    }
    setError('');
    onSave(form);
  };

  return (
    <div className="modal d-block" tabIndex={-1} style={{ background: 'rgba(0,0,0,0.3)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit LicState</h5>
            <button type="button" className="btn-close" onClick={onCancel}></button>
          </div>
          <div className="modal-body">
            {error && <div className="alert alert-danger">{error}</div>}
            <div className="mb-2">
              <label className="form-label">State Name *</label>
              <input className="form-control" name="state" value={form.state} onChange={handleChange} required />
            </div>
            <div className="mb-2">
              <label className="form-label">State ID *</label>
              <input className="form-control" name="stateID" type="number" value={form.stateID} onChange={handleChange} required />
            </div>
            <div className="mb-2">
              <label className="form-label">Note</label>
              <input className="form-control" name="note" value={form.note || ''} onChange={handleChange} />
            </div>
            <div className="mb-2">
              <label className="form-label">Link</label>
              <input className="form-control" name="link" value={form.link || ''} onChange={handleChange} />
            </div>
            <div className="mb-2">
              <label className="form-label">LU</label>
              <input className="form-control" name="LU" type="number" value={form.LU ?? ''} onChange={handleChange} />
            </div>
            <div className="mb-2">
              <label className="form-label">LU Lecture</label>
              <input className="form-control" name="LULecture" type="number" value={form.LULecture ?? ''} onChange={handleChange} />
            </div>
            <div className="mb-2">
              <label className="form-label">LU Self</label>
              <input className="form-control" name="LUSelf" type="number" value={form.LUSelf ?? ''} onChange={handleChange} />
            </div>
            <div className="mb-2">
              <label className="form-label">LU Access</label>
              <input className="form-control" name="LUAccess" type="number" value={form.LUAccess ?? ''} onChange={handleChange} />
            </div>
            <div className="mb-2">
              <label className="form-label">LU Energy</label>
              <input className="form-control" name="LUEnergy" type="number" value={form.LUEnergy ?? ''} onChange={handleChange} />
            </div>
            <div className="mb-2">
              <label className="form-label">Cycle Start</label>
              <input className="form-control" name="CycleStart" type="date" value={form.CycleStart ? String(form.CycleStart).slice(0,10) : ''} onChange={handleChange} />
            </div>
            <div className="mb-2">
              <label className="form-label">Cycle End</label>
              <input className="form-control" name="CycleEnd" type="date" value={form.CycleEnd ? String(form.CycleEnd).slice(0,10) : ''} onChange={handleChange} />
            </div>
            <div className="mb-2">
              <label className="form-label">Cycle Period</label>
              <input className="form-control" name="CylePeriod" value={form.CylePeriod || ''} onChange={handleChange} />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
            <button type="button" className="btn btn-primary" onClick={handleSave}>Save</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LicStateEdit;
